var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRedClose = function SvgRedClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EF4444",
    d: "M16.5 1.778C8.658 1.778 2.277 8.158 2.277 16S8.657 30.222 16.5 30.222c7.841 0 14.222-6.38 14.222-14.222S24.342 1.778 16.5 1.778m5.83 18.169a1.334 1.334 0 0 1-1.884 1.886L16.5 17.886l-3.947 3.947a1.33 1.33 0 0 1-1.885 0 1.334 1.334 0 0 1 0-1.886L14.616 16l-3.947-3.947a1.334 1.334 0 1 1 1.887-1.886l3.946 3.947 3.947-3.947a1.334 1.334 0 1 1 1.886 1.886L18.388 16l3.946 3.947z"
  })));
};
export default SvgRedClose;